import React, { useState, useEffect } from 'react'
import MasterPage from '../Templates/MasterPage'
import Footer from '../Templates/Footer'
import {server} from '../server'
import { Company_Id } from '../Helper'
import { Corporate_Id } from '../Helper'
import { Corporate_Name } from '../Helper'
import { Vendor_Id } from '../Helper'
import { Vendor_Name } from '../Helper'
import Swal from 'sweetalert2'
import { Navigate } from 'react-router'
import { Link, useNavigate, useLocation } from 'react-router-dom';


//export default class UpcomingTrips extends Component {
    function UpcomingTrips() {
        const navigate = useNavigate();
        let JWTToken = localStorage.getItem('Token');
        const statusStyle={
            backgroundColor: '#3498db',
            color: 'white',
            padding: '1px 5px 4px 4px'
        }
        const [upcomingTrips, setupcomingTrips] = useState([]);
        let userMobNo=localStorage.getItem('contactNo');
      
        
        
        // useEffect(() => {
        //     fetch(`${server}/api/O3Mobility/TripHistoryO3/${Company_Id}/${Corporate_Id}/${Corporate_Name}/${Vendor_Id}/${userMobNo}`)
        //         .then((result) => {
        //             console.log("---------");
        //             console.log(result);
        //             result.json().then((resp) => {
        //               //  setCompletedTrips(resp.lsttripHistory);
        //                 var updatedList = [...resp.lsttripHistory];
        //                 updatedList = updatedList.filter((item) => {
        //                     return item.tripStatus== 'Not Started' || item.tripStatus=='Dispatching';
        //                 });
        //                 setupcomingTrips(updatedList);
        //             })
    
        //         })
        // }, [])



        function CancelRide(JobNo) {
            const userId = localStorage.getItem("userid");
            const encryptedJobNo = btoa(JobNo); 
            const encrypteduserId =btoa(userId);
            const payload = { jobId: encryptedJobNo,Userid:encrypteduserId };
        
          

            fetch(`${server}/api/O3Mobility/CancelTrip/${Company_Id}/${Corporate_Id}/${Corporate_Name}/${Vendor_Id}`, {
                method: 'POST',
                headers: {
                    'Authorization': `${JWTToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then((response) => {
                    if (response.status === 200) {
                        console.log('Trip successfully canceled');
                        Swal.fire({
                            icon: 'success',
                            title: 'Trip Canceled',
                            text: 'The trip has been successfully canceled.',
                        });
                    } else if (response.status === 401) {
                        console.error('Unauthorized access: Session expired.');
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Session Expired',
                        });
                        localStorage.clear();
                        navigate('/Login');
                    } else {
                        console.error(`Error: ${response.status}`);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: `Unable to cancel the trip. Status Code: ${response.status}`,
                        });
                    }
                })
                .catch((error) => {
                    console.error('Network error:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Network Error',
                        text: 'Failed to connect to the server. Please try again later.',
                    });
                });
        }
        

        useEffect(() => {
           
            fetch(`${server}/api/O3Mobility/TripHistoryO3/${Company_Id}/${Corporate_Id}/${Corporate_Name}/${Vendor_Id}`,
                { method: 'GET', headers: { 'Authorization': `${JWTToken}`, 'Content-Type': 'application/json', }}
            )
                .then((result) => {
                   
                    if (result.status === 404) {
                        console.error('Error 404: Resource not found.');
                       
                        return;
                    }
                   
        
                    result.json().then((resp) => {
                       
                         if (resp.statusCode == 401) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Session Expired',
                            });
                            localStorage.clear();
                            navigate('/Login');

                         }
                        if (Array.isArray(resp.lsttripHistory)) {
                            var updatedList = [...resp.lsttripHistory];
                            updatedList = updatedList.filter((item) => {
                                return item.tripStatus == 'Not Started' || item.tripStatus == 'Dispatching' || item.tripStatus == 'Vehicle Assigned' ||  item.tripStatus == 'Reached PickUp' ;
                            });
                            setupcomingTrips(updatedList);
                          
                        } else {
                            console.error('lsttripHistory is not an array:', resp.lsttripHistory);
                        }
                    }).catch((error) => {
                        console.error('Error parsing JSON:', error);
                    });
        
                }).catch((error) => {
                    console.error('Fetch error:', error);
                   
                });
        }, []);
        
    
        return (
            <div>
                <>
                    <div>
                        <MasterPage />
                    </div>
                    <div>
                        <div className="content-wrapper" style={{ minHeight: '704.8px' }}>
                            {/* Content Header (Page header) */}
                            <section className="content-header">
                                <div className="container-fluid">
                                    <div className="row mb-2">
                                        <div className="col-sm-6">
                                            <h1>Upcoming Trips</h1>
                                        </div>
                                        <div className="col-sm-6">
                                            <ol className="breadcrumb float-sm-right">
                                                <li className="breadcrumb-item"><a href="#">Home</a></li>
                                                <li className="breadcrumb-item active">Upcoming Trips</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            
                            <section className="content">
                                <div className="container-fluid">

                                    <div className="card card-warning">
                                        <div className="card-header">
                                            <h3 className="card-title">Upcoming Trips Details</h3>
                                        </div>
                                        <div className="card-body overflow" >
                                        <div className='row'>
                                        <table className="table table-striped">
    <thead>
        <tr>
            <th scope="col">SrNo.</th>
            <th scope="col">BookingID</th>
            <th scope="col">Booking Date</th>
            <th scope="col">Trip Date</th>
            <th scope="col">Pickup Location</th>
            <th scope="col">Drop Location</th>
            <th scope="col">Fare</th>
            <th scope="col">PaymentType</th>
            {/* <th scope="col">Trip Fare</th> */}
            <th>Status</th>
            {/* <th>Action</th>  */}
        </tr>
    </thead>
    <tbody>
            {upcomingTrips && upcomingTrips.length > 0 ?
                upcomingTrips.map((data, index) => {

                    // const tripDateTimeString = data.tripDateTime; // e.g., "4/1/2025 12:30:00 PM"
                    // const tripDateTime = new Date(tripDateTimeString); // Parse the date
                    
                    // const currentTime = new Date(); // Current system time
                    // const timeDiff = (tripDateTime - currentTime) / (1000 * 60 * 60); // Difference in hours
                
                    // console.log('tripDateTime:', tripDateTime);
                    // console.log('currentTime:', currentTime);
                    // console.log('timeDiff:', timeDiff);
                
                
                    return (
                        <tr key={data.id}>
                            <td>{index + 1}.</td>
                            <td>{data.id}</td>
                            <td>{data.jobCreationTime}</td>
                            <td>{data.tripDateTime}</td>
                            <td>{data.pickupAddress}</td>
                            <td>{data.dropAddress}</td>
                            <td>{data.calculatedBasefare}</td>
                            <td>{data.billingType}</td>
                            <td><small style={statusStyle}>{data.tripStatus}</small></td>
                            <td>
                                
                                    <button onClick={() => CancelRide(data.id)}>Cancel</button>
                               
                            </td>
                        </tr>
                    );
                }) :
                <>No record</>
            }
        </tbody>


</table>



                                        </div>


                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                </div>{/*/. container-fluid */}
                            </section>
                            {/* /.content */}
                        </div>
                    </div>
                    <div>
                        <Footer />
                    </div>
                </>
            </div>
        )
    }
export default UpcomingTrips;

